import { Text, Heading, Card } from '@chakra-ui/react';

const DashboardHeader = (): JSX.Element => {
  return (
    <Card gap={'4px'} width={['auto', 'auto', '668px']} variant={'unstyled'}>
      <Heading fontWeight={'500'} fontSize={['1.75rem', '1.75rem', '2.25rem']}>
        Portal de recaudos
      </Heading>
      <Text fontSize={['1rem', '1rem', '1.125rem']}>
        Acá podrás ver todas tus facturas y gestionar pagos únicos o frecuentes.
      </Text>
    </Card>
  );
};
export default DashboardHeader;
